import ReactIcon from '../icons/ReactIcon';
import HtmlIcon from '../icons/HtmlIcon';
import CssIcon from '../icons/CssIcon';
import JavaScriptIcon from '../icons/JavaScriptIcon';
import JsonIcon from '../icons/JsonIcon';
import ReadmeIcon from '../icons/ReadmeIcon';

export const menu = [
  {
    Icon: ReactIcon,
    path: '/',
    text: 'home.jsx',
  },
  {
    Icon: HtmlIcon,
    path: '/about',
    text: 'about.html',
  },
  {
    Icon: CssIcon,
    path: '/skills',
    text: 'skills.css',
  },
  {
    Icon: JavaScriptIcon,
    path: '/study',
    text: 'study.js',
  },
  {
    Icon: JsonIcon,
    path: '/projects',
    text: 'projects.json',
  },
  {
    Icon: ReadmeIcon,
    path: '/readme',
    text: 'README.md',
  },
];
